import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div class='loadingio-spinner-eclipse-hfd1pw4w86p'>
      <div class='ldio-szxym9299t'>
        <div />
      </div>
    </div>
  );
};

export default Loader;
